import styled from 'styled-components';

const InsuredDriverWrapper = styled.div`

.insured-wrapper{
    // background-image: linear-gradient(to bottom, #f9fdff 0%, rgba(249, 253, 255, 0) 100%), linear-gradient(to bottom, #fff, #fff);
    padding: 1rem 0;
    h2{
        font-size: 24px;
        font-weight: bold;
        color: #4c565c;
        margin: 1rem 0;
        text-align: initial;
    }

    .drivers-list{
        display: flex;
        flex-direction: column;
        .item{
          display: flex;
          border: solid 1px #edf2f5;
          background-color: #fff;
          align-items: center;
          justify-content: space-between;
          padding: 10px 16px;
          margin: 1rem 0 0;
          .details{
            display: inline-flex;
            text-align: initial;
            img{
              height: 48px;
              margin-right: 10px;
            }
            .btns{
              display: none;
            }
          }
          .divider{
                height: 30px;
                border-right: 1px solid #edf2f5;
          }
          .iqama{
            text-align: initial;
          }
          .name{
            text-align: initial;
            // color: #4c565c !important;
          }
          .license{
            font-size: 13px;
            font-weight: bold;
            color: #6B47F5;
            margin-bottom: 0;
            text-align: initial;
          }
          .header-title{
            height: 13px;
            // font-family: 'Bliss2', Tahoma, Geneva, Verdana, sans-serif;
            font-size: 13px;
            color: #818b9b;
            margin-bottom: 5px;
            text-align: initial;

          }
          .usage{
            .header-title{
              margin-bottom: 10px;
            }
            button:disabled {
              cursor: not-allowed;
              pointer-events: all !important;
              opacity: 0.8;
            }
          }
          .usage-list{
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            .item{
              cursor: pointer;
              width: 37px;
              height: 28px;
              flex-grow: 0;
              display: inline-flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 5px;
              border-radius: 0;
              border: solid 1px #6B47F5;
              margin: 0 5px 0 0;
              span{
                font-size: 13px;
                color: #6B47F5;
              }
              &.active{
                background-color: #6B47F5;
                border-color: #6B47F5;
                span{
                  color: #fff;
                }
              }
            }
          }
  
          .btns{
            display: inline-flex;
            .btn{
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: 24px;
              height: 24px;
              border-radius: 50%;
              padding: 0;
              &:first-of-type{
                margin-right: 12px;
              }
                
            }
            .danger{
              background: #ef2f2f;
              padding: 0;
              margin: 0 5px 0 0;
            }
            .primary{
              padding: 0;
              margin: 0;
            }
          }
        }
      }

      @media only screen and (max-width: 768px) {
        .drivers-list{
          .divider{
            display: none
          }
          .item{
            flex-direction: column;
            .details, .iqama, .year-birth, .usage{
              width: 100%;
              display: inline-flex;
              justify-content: space-between;
              padding-bottom: 10px;
              padding-top: 10px;
              border-bottom: 1px solid  #edf2f5;
              .header-title{
                margin: 0
              }
            }
            .details{
              .btns{
                display: block;
              }
            }
            .actions{
              display: none;
            }
            .usage{
              border-bottom: 0;
              .header-title{
                padding-top: 5px;
              }
              .item{
                // display: none;
                &.active{
                  display: inline-flex;
                  // margin: 0;
                }
              }
            }
            .btns{
              height: 24px;
              img{
                height: 24px;
              }
              margin-right: 0;
              margin-left: auto;
            }
          }
        }
      }

      &.ar{
        .btns{
            .btn{
              &:first-of-type{
                margin-right: 0 !important;
                margin-left: 12px !important;
            }
          margin-left: 0;
          margin-right: auto;     
        }        
      }
}

`;
export default InsuredDriverWrapper;